import { type ChangeEvent, useCallback } from 'react';

type Props = {
    allowedMimeTypes: string[];
    onUploaded: (file: File) => void;
    onInvalidType: (userMessage: string) => void;
    onClear: () => void;
};

export function useCategoryModalFileUpload({
    allowedMimeTypes,
    onUploaded,
    onInvalidType,
    onClear,
}: Props) {
    const handleMediaChange = useCallback(
        (e: ChangeEvent<HTMLInputElement>) => {
            const file = e.target.files?.[0];
            if (file) {
                if (!allowedMimeTypes.includes(file.type)) {
                    onInvalidType(
                        `Format de fichier non supporté. Seuls les fichiers ${allowedMimeTypes.join(', ')} sont acceptés.`,
                    );
                    return;
                }
                onUploaded(file);
            } else {
                onClear();
            }
        },
        [allowedMimeTypes, onInvalidType, onClear, onUploaded],
    );

    return { handleMediaChange };
}
